module.exports = __webpack_public_path__ + "background.1e5524636f6ff01f7b9b.png";


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/assets/img/background.png
// module id = ../../../../../src/assets/img/background.png
// module chunks = main